import { FC } from "react";
import { SiteBody } from "@vviinn/user-managment-client-ts";

import { SiteNets } from "../types";
import { CustomSiteFields } from "../CustomSiteFields";
import { ItemGrouping } from "../ItemGrouping";
import { FeedHistory } from "../../../feed/FeedHistory";
import { FeedSourcesBlock } from "./FeedSourcesBlock";
import { TypedBooleanPromise } from "../../../helpers/functions/types";
import { SubSectionWithStyles } from "../../../ui/layout";

type FeedEditBlockProps = {
  config: Partial<SiteNets>;
  updateSiteField: TypedBooleanPromise<SiteBody>;
  refinementColumns: string[];
};

export const FeedEditBlock: FC<React.PropsWithChildren<FeedEditBlockProps>> = ({
  config,
  updateSiteField,
  refinementColumns,
}) => {
  return (
    <SubSectionWithStyles title="Data source">
      <FeedSourcesBlock />
      <CustomSiteFields />
      <FeedHistory />

      <ItemGrouping
        groupItems={config.productUniquenessLevel === "item_group_id"}
        refinementColumns={refinementColumns}
        updateSiteField={updateSiteField}
      />
    </SubSectionWithStyles>
  );
};
